import { connect } from 'react-redux'
import ActivateUserPage from '../../ActivateUser/components/ActivateUserPage'
import PermissionDenied from '../../../../Unauthorized/components/PermissionDenied'
import { actions } from '../../ActivateUser/modules/ActivateUser'

const mapStateToProps = state => state.resetPassword

const mapDispatchToProps = actions

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(props => {
  if (props.userToken) {
    return ActivateUserPage(props, true)
  }
  return PermissionDenied(props)
})
